module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }